'use client';

import { useEffect } from 'react';
import type { IBreadcrumbItem } from '../_breadcrumb/types';
import { useHeaderActions } from './header-actions-context';

interface ISetBreadcrumbLabelProps {
  label: string;
  parentItems?: IBreadcrumbItem[];
  append?: boolean;
}

export function SetBreadcrumbLabel({ label, parentItems, append }: ISetBreadcrumbLabelProps): null {
  const { setBreadcrumbOverride } = useHeaderActions();

  useEffect(() => {
    setBreadcrumbOverride({ label, parentItems, append });
    return () => setBreadcrumbOverride(null);
  }, [label, parentItems, append, setBreadcrumbOverride]);

  return null;
}
